import { Modal } from "react-bootstrap";
import styles from "./modal.module.css";
import { DioramaSpaceType } from "../../pages/admin/files/artwork";
import React from "react";
import { uploadArtworkModelFile } from "../../pages/admin/files/service";

interface ModalProps {
    show: boolean;
    onHide: () => void;
    onSubmitted: (status: boolean) => void;
    isDiorama: boolean;
    types: string;
    artwork: DioramaSpaceType;
    file: File;
}

export const ArtworkFileConfirmModal = ({show, onHide, onSubmitted, file, isDiorama, types, artwork}: ModalProps) => {
    
    const [ updating, setUpdating ] = React.useState<boolean>(false);
    const updateModel = async () => {
        try {
            setUpdating(true);
            const respData = await uploadArtworkModelFile(file, types, artwork ? artwork.id : "");
            
            if (respData.status) {
                onSubmitted(true);
                onHide();
            } else {
                onSubmitted(false);
            }
        } catch (error) {
            
        } finally {
            setUpdating(false);
        }
    }
    
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton className={styles.background}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Are you sure to update artwork(s) model file?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.background}>
                <div className="p-3">
                    <div>Diorama: &nbsp; {isDiorama ? "Yes" : "No"}</div>
                    <div>
                        {!isDiorama ? <>
                            Artwork Type: &nbsp; {types}
                        </> : <>
                            <div>Diorama Name: &nbsp; {artwork ? artwork.name : ""}</div>
                            <div>Gallery Type: &nbsp; {artwork ? artwork.galleryDetail.spaceType : ""}</div>
                        </>}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.background}>
                <button className="btn btn-success" onClick={onHide}>
                    Close
                </button>
                <button
                    className="btn btn-success" 
                    onClick={updateModel} 
                    disabled={updating}
                >
                    {updating ? "Submitting..." : "Submit"}
                </button>
            </Modal.Footer>
        </Modal>
    )
}